/* eslint-disable max-len */
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ManageLogHoleSizeColumn } from '.';

export interface ManageLogHoleSizeTableHeadProps {
  columns: ManageLogHoleSizeColumn[];
};

export const ManageLogHoleSizeTableHead = memo((props: ManageLogHoleSizeTableHeadProps) => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        {
          props.columns.map((col) => (
            <th
              key={`head-${col.id}`}
              style={{ width: col.maxWidth }}
            >
              {t(col.label).toUpperCase()}
            </th>
          ))
        }
      </tr>
    </thead>
  );
});

ManageLogHoleSizeTableHead.displayName = 'ManageLogHoleSizeTableHead';
